import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wc-particles" }
const _hoisted_2 = {
  key: 0,
  class: "wc-loading"
}
const _hoisted_3 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  class: "wc-check"
}
const _hoisted_4 = {
  key: 1,
  class: "wc-rocket"
}
const _hoisted_5 = {
  key: 0,
  class: "wc-burst"
}
const _hoisted_6 = {
  key: 0,
  class: "wc-live"
}
const _hoisted_7 = { class: "wc-title" }
const _hoisted_8 = { class: "wc-sub" }
const _hoisted_9 = { class: "wc-cell-name" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "wc-btn-spin"
}
const _hoisted_12 = { class: "wc-secondary" }
const _hoisted_13 = {
  key: 1,
  class: "wc-sep"
}

import { ref, onMounted, onUnmounted, watch, nextTick } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WalkthroughCelebration',
  props: {
    loading: { type: Boolean },
    isActive: { type: [Boolean, null] },
    activating: { type: Boolean },
    activated: { type: Boolean }
  },
  emits: ["close", "activate", "replay"],
  setup(__props: any) {

/* eslint-disable no-undef */
const props = __props;



const features = [
  { icon: '📊', label: 'Dashboard', color: 'blue' },
  { icon: '👥', label: 'Customers', color: 'purple' },
  { icon: '🧠', label: 'AI Engine', color: 'amber' },
  { icon: '✉️', label: 'Templates', color: 'green' },
  { icon: '📋', label: 'Lead Forms', color: 'rose' },
  { icon: '🔌', label: 'Integrations', color: 'teal' }
];

const visible = ref(false);
const stage = ref(0);
const burst = ref(false);
const flash = ref(false);
let timers: ReturnType<typeof setTimeout>[] = [];

function start() {
  stop();
  visible.value = true;
  const t = (ms: number, fn: () => void) => timers.push(setTimeout(fn, ms));

  t(100, () => {
    stage.value = 1;
    burst.value = true;
  });
  t(700, () => {
    stage.value = 2;
  });
  t(1300, () => {
    stage.value = 3;
  });
  t(1900, () => {
    stage.value = 4;
  });
  t(1400, () => {
    burst.value = false;
  });
}

function stop() {
  timers.forEach(clearTimeout);
  timers = [];
  stage.value = 0;
  visible.value = false;
  burst.value = false;
}

// Start animation once loading finishes
watch(
  () => props.loading,
  (now, prev) => {
    if (prev === true && now === false) {
      nextTick(() => start());
    }
  }
);

// Flash when activation succeeds
watch(
  () => props.activated,
  (now, prev) => {
    if (now && !prev) {
      flash.value = true;
      timers.push(setTimeout(() => (flash.value = false), 1000));
    }
  }
);

onMounted(() => {
  if (!props.loading) start();
});

onUnmounted(() => stop());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wc", { 'wc--visible': visible.value, 'wc--flash': flash.value }])
  }, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "wc-accent" }, null, -1)),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "wc-bg" }, null, -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["wc-glow", _ctx.isActive ? 'wc-glow-green' : 'wc-glow-amber'])
    }, null, 2),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "wc-scan" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
        return _createElementVNode("div", {
          key: i,
          class: _normalizeClass(["wc-pt", `wc-pt-${i}`])
        }, null, 2)
      }), 64))
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "wc-spinner" }, null, -1),
          _createElementVNode("p", { class: "wc-loading-label" }, "Checking your setup…", -1)
        ]))]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            class: _normalizeClass(["wc-icon", { show: stage.value >= 1 }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["wc-core", _ctx.isActive ? 'wc-core-green' : 'wc-core-amber'])
            }, [
              (_ctx.isActive)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("path", {
                      d: "M7 12l4 4 6-7",
                      stroke: "white",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "🚀"))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["wc-ring wc-r1", _ctx.isActive ? 'wc-ring-green' : 'wc-ring-amber'])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["wc-ring wc-r2", _ctx.isActive ? 'wc-ring-green' : 'wc-ring-amber'])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["wc-ring wc-r3", _ctx.isActive ? 'wc-ring-green' : 'wc-ring-amber'])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["wc-orbit wc-orb-1", _ctx.isActive ? 'wc-orbit-green' : 'wc-orbit-amber'])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["wc-orbit wc-orb-2", _ctx.isActive ? 'wc-orbit-green' : 'wc-orbit-amber'])
            }, null, 2),
            (burst.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (j) => {
                    return _createElementVNode("div", {
                      key: j,
                      class: _normalizeClass(["wc-bd", `wc-bd-${j}`])
                    }, null, 2)
                  }), 64))
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["wc-hero", { show: stage.value >= 2 }])
          }, [
            (_ctx.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "wc-live-dot" }, null, -1),
                  _createTextVNode(" LIVE ", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.isActive ? 'Your AI is Live' : 'Ready to Launch'), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.isActive
              ? 'Analyzing customers and sending personalized messages — completely on autopilot.'
              : "Everything's configured. One click and your AI starts reaching customers immediately."), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["wc-grid", { show: stage.value >= 3 }])
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (f, i) => {
              return _createElementVNode("div", {
                key: i,
                class: "wc-cell",
                style: _normalizeStyle({ transitionDelay: `${i * 80}ms` })
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["wc-cell-icon", `wc-ci-${f.color}`])
                }, _toDisplayString(f.icon), 3),
                _createElementVNode("span", _hoisted_9, _toDisplayString(f.label), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "wc-cell-chk" }, "✓", -1))
              ], 4)
            }), 64))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["wc-actions", { show: stage.value >= 4 }])
          }, [
            (_ctx.isActive)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "wc-btn wc-btn-dash",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Go to Dashboard ", -1),
                  _createElementVNode("span", { class: "wc-arrow" }, "→", -1)
                ]))]))
              : (_openBlock(), _createBlock(_Transition, {
                  key: 1,
                  name: "wc-swap",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.activated)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: "done",
                          class: "wc-btn wc-btn-done",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                        }, [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" ✓ You're Live — Go to Dashboard ", -1),
                          _createElementVNode("span", { class: "wc-arrow" }, "→", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: "go",
                          class: "wc-btn wc-btn-go",
                          disabled: _ctx.activating,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('activate')))
                        }, [
                          (_ctx.activating)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.activating ? 'Activating…' : '⚡ Go Live'), 1)
                        ], 8, _hoisted_10))
                  ]),
                  _: 1
                })),
            _createElementVNode("div", _hoisted_12, [
              (!_ctx.isActive)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "wc-link",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
                  }, " Explore first "))
                : _createCommentVNode("", true),
              (!_ctx.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "·"))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "wc-link",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('replay')))
              }, "Replay Tour")
            ])
          ], 2)
        ], 64))
  ], 2))
}
}

})